import { Component, OnInit, Injector, ViewChild, AfterContentInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProductProductPricesStocksComponent } from '../../components/product-prices-stocks/product-prices-stocks.component';
import { ProductProductAddToOrderComponent } from '../../components/product-add-to-order/product-add-to-order.component';
import { ProductProductAssociatedItemsComponent } from '../../components/product-associated-items/product-associated-items.component';
import { IProductOrderItem } from '../../models/product-order-item';
import { sumBy } from 'lodash';
import { OOEApiServiceProxy } from '../../services/ooe-api-service-proxy';
import { ItemAvaibility } from '../../models/itemAvailability.model';
import { AddItemToOrderInputDto, AddItemToOrderV2InputDto } from '../../models/addItemToOrder.model';
import { Store } from '@ngrx/store';
import { getStateSelectedVehicle, getStateShowedUniversalProducts, getStateUsedAsFilter } from '../../+store/vehicles';
import { Subject, from, Observable, combineLatest, BehaviorSubject, of, throwError, EMPTY } from 'rxjs';
import {
  GetProductDetailInput,
  GetProductDetailOutput,
  ProductRichContentDto,
  ProductAttributeDto,
  DetailLevel,
  ProductAssociatedItem,
} from '../../models/service-proxies';
import { FetchItemPriceGroupItemPriceObject } from '../../models/fetItemPriceGroup.model';
import { takeUntil, finalize, map, concatMap, withLatestFrom, debounceTime, skip, catchError, tap } from 'rxjs/operators';
import { AppConsts } from '../../constants/AppConsts';
import { IOOEOrder } from '../../models/userState.model';
import { ToastrService } from 'ngx-toastr';
import { GetPriceAndStockInput, PriceAndStock } from '../../models/price-and-stock.model';
import { EpcApiService } from '../../services/epc-api.service';
import { AssociatedItem, GetProductDetails } from '../../models/product-details';
import { MessageService, DialogService } from '@pos-app/core-ui';
import { OOESessionService } from '../../../../../../../../libs/core-ui/src/lib/services/ooe-session.service';
import { IMainState } from '../../+store';
import { LayoutService } from '@pos-app/core-ui/lib/services/layout.service';

@Component({
    selector: 'app-product',
    templateUrl: './product.component.html',
    styleUrls: ['./product.component.scss'],
    standalone: false
})
export class ProductComponent implements OnInit, AfterContentInit {
  @ViewChild('pricesStocks', { static: false })
  public pricesStocksComponent: ProductProductPricesStocksComponent;
  @ViewChild('addToOrder', { static: false })
  public addToOrderComponent: ProductProductAddToOrderComponent;
  @ViewChild('associatedItems', { static: false })
  public associatedItemsComponent: ProductProductAssociatedItemsComponent;

  public currencyCode: string;
  public active: number = 1;
  private isProductLoadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isProductLoading$ = this.isProductLoadingSubject.asObservable();
  public get isProductLoading(): boolean {
    return this.isProductLoadingSubject.getValue();
  }
  public productNotFound: boolean = false;
  public branchId: number;
  public productQuery: GetProductDetailInput = new GetProductDetailInput();
  public productOutput: GetProductDetailOutput = new GetProductDetailOutput();
  public mainProduct: IProductOrderItem;
  public includeParent = true;
  public failedOrderItemNumbers = new Set<string>();
  public failedOrderItemMessages = new Map<string, string>();
  public associatedItems: IProductOrderItem[] = [];
  public configuredPrices: any[] = [];
  public hasAssociatedItemWarning: boolean = true;
  public hasAssociatedFittmentWarning: boolean = true;
  public selectedVehicleId: any;
  public useVehicleInFilter: boolean;
  public showedUniversalProducts: boolean;
  public isFitted: boolean;
  public isEAIRules: boolean = true;
  public openOrder: IOOEOrder;
  public productInfoAttribute: ProductAttributeDto[];
  public productFitmentInfoAttribute: ProductAttributeDto[];
  public priceAndStockItems: PriceAndStock[] = [];
  public readOnlyEPCTF: boolean;
  userUncheckedMandatoryItemList: IProductOrderItem[] = [];
  bundleSupplementryGroupSelected: boolean;
  nonBundleSupplementryGroupSelected: boolean = false;
  mainBundleSupplementryGroupSelected: boolean = false;
  isParentUnitFitCharge: boolean = false;
  isSubItemSelected: boolean = false;
  combinedFitSupplementryGroupSelected: boolean;
  combinedPaintSupplementryGroupSelected: boolean;

  public get isUserloggedIn(): boolean {
    return this.ooeSessionService.loginedSession != null;
  }

  public get userPostCode(): string {
    return this.ooeSessionService.getUserPostCode().trim();
  }

  private componentDestroyed$ = new Subject<void>();

  constructor(
    public injector: Injector,
    private epcApiService: EpcApiService,
    private store: Store<IMainState>,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private ooeAPIServiceProxy: OOEApiServiceProxy,
    private messageService: MessageService,
    private ooeSessionService: OOESessionService,
    private layoutService: LayoutService,
    private dialogService: DialogService,
  ) {}

  public ngOnInit(): void {
    this.layoutService.setIsSpotlightHidden(true);

    this.route.paramMap
      .pipe(
        takeUntil(this.componentDestroyed$),
        withLatestFrom(combineLatest([this.store.select(getStateUsedAsFilter), this.store.select(getStateSelectedVehicle)])),
      )
      .subscribe(([params, [usedAsFilter, vehicle]]) => {
        this.productQuery.productNumber = decodeURIComponent(params.get('productNumber'));
        this.useVehicleInFilter = usedAsFilter;
        this.selectedVehicleId = vehicle ? Number(vehicle.partsVehicleID) : undefined;

        if (this.productQuery && this.productQuery.productNumber) {
          this.getProductDetail();
        }
      });

    combineLatest([
      this.store.select(getStateUsedAsFilter),
      this.store.select(getStateSelectedVehicle),
      this.store.select(getStateShowedUniversalProducts),
    ])
      .pipe(
        takeUntil(this.componentDestroyed$),
        map((data) => {
          const [usedAsFilter, selectedVehicle, showedUniversalProducts] = data;

          this.useVehicleInFilter = usedAsFilter;
          this.selectedVehicleId = selectedVehicle ? Number(selectedVehicle.partsVehicleID) : undefined;
          this.showedUniversalProducts = showedUniversalProducts;

          return data;
        }),
        debounceTime(500),
        skip(1),
      )
      .subscribe((data) => {
        if (this.productOutput.productInfo) {
          this.getProductDetail();
        }
      });

    this.messageService
      .listen('postcodeUpdate')
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(() => {
        this.refreshPricesWithPostCode();
      });
    this.messageService
      .listen('userStateUpdate')
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(() => {
        this.refreshPricesWithPostCode();
      });
  }

  public ngAfterContentInit(): void {
    if (this.ooeSessionService.loginedSession) {
      this.getOpenOrder();
      this.ooeSessionService.ooeUserState$.pipe(takeUntil(this.componentDestroyed$)).subscribe(() => {
        this.getOpenOrder();
      });
    }
  }

  public ngOnDestroy(): void {
    this.layoutService.setIsSpotlightHidden(false);

    this.componentDestroyed$.next();
    this.componentDestroyed$.complete();
  }

  public getOpenOrder(): void {
    this.openOrder = this.ooeSessionService.openOrder;
    this.readOnlyEPCTF = this.openOrder?.readOnlyEPCTF;
  }

  public updateMainProductPrices(): void {
    if (!this.ooeSessionService.loginedSession && !this.ooeSessionService.getUserPostCode().trim()) {
      return;
    }
    this.associatedItems.forEach((item) => {
      // if (
      //   (this.isEAIRules && item.associatedType === 'Mandatory') ||
      //   item.associatedType === 'Mandatory Bundle' ||
      //   item.associatedType === 'Optional'
      // ) {
      // Update quantity to match mainQuantity
      item.quantity = this.mainProduct.quantity * (item.originalQuantity || 1);
      //}
    });
    this.updateOrderConfiguredPrices();
  }

  public get selectedOrderItemCount(): number {
    if (!this.mainProduct || !this.openOrder) {
      return 0;
    }
    const selectedItems: AddItemToOrderInputDto[] = [];
    this.getNewItem(selectedItems, this.mainProduct, this.associatedItems, []);
    return selectedItems.length;
  }

  public addItemToOrder(quantity: number, isCreatedOrderSilent = false): void {
    this.failedOrderItemNumbers = new Set<string>();
    this.failedOrderItemMessages = new Map<string, string>();
    if (!this.ooeSessionService.hasActiveOrder && isCreatedOrderSilent == false) {
      this.createOrderSilent(quantity);
      return;
    }

    let selectedItems: AddItemToOrderInputDto[] = [];
    const sourceItems: IProductOrderItem[] = [];
    const successfulItems = new Set<IProductOrderItem>();
    const parentAtClick = this.mainProduct;

    // Add main product and mandatory items
    this.getNewItem(selectedItems, this.mainProduct, this.associatedItems, sourceItems);

    let selectedItemsV2: AddItemToOrderV2InputDto[] = selectedItems.map((item) => {
      let productLine = new AddItemToOrderV2InputDto();
      productLine.orderNumber = item.orderNumber;
      productLine.itemNumber = item.parentItemCode;
      productLine.quantity = item.quantity;
      productLine.overridePriceYN = 'N';
      productLine.useEPCYN = 'Y';
      productLine.fetchInventoryYN = 'Y';
      productLine.enforceMandatoryAssociationYN = this.isEAIRules ? 'Y' : 'N';
      productLine.fitYN = item.fittedYN;
      productLine.paintYN = item.paintYN;
      productLine.unitPriceEx = 0;
      productLine.unitPriceInc = 0;
      productLine.sourceSystem = 'EPC';

      return productLine;
    });

    // Snapshot the count at the moment of "Add To Order" click; any items selected after this point are excluded.
    const selectedItemsCountAtClick = selectedItemsV2.length;
    let productAddedCount = 0;
    let productAddedCountFinal = 0;
    let orderLinesToRefresh = 0;
    let batchCompleted = false;
    const refreshUserState = () => {
      if (batchCompleted && orderLinesToRefresh > 0 && productAddedCountFinal === orderLinesToRefresh) {
        this.ooeSessionService
          .fetchUserState()
          .pipe(takeUntil(this.componentDestroyed$))
          .subscribe(({ OpenOrder }) => {
            this.openOrder = OpenOrder;
          });
      }
    };
    from(selectedItemsV2)
      .pipe(
        concatMap((item, index) => {
          return this.ooeAPIServiceProxy.addItemToOrder(item).pipe(
            concatMap((result) => {
              if (!result || result.ErrorFlag === '1') {
                return throwError(() => result?.ErrorMessage || 'Unable to add item to order. Please try again.');
              }
              return of({ result, sourceItem: sourceItems[index] });
            }),
            catchError((error: unknown) => {
              const message = typeof error === 'string' && error ? error : 'Unable to add item to order. Please try again.';
              this.failedOrderItemNumbers = new Set([...this.failedOrderItemNumbers, item.itemNumber]);
              this.failedOrderItemMessages = new Map(this.failedOrderItemMessages).set(item.itemNumber, message);
              this.toastr.error(message);
              return EMPTY;
            }),
          );
        }),
        tap({
          complete: () => {
            batchCompleted = true;
            refreshUserState();
          },
        }),
        takeUntil(this.componentDestroyed$),
        finalize(() => {
          const selectionsChanged = this.uncheckSuccessfulOrderItems(this.associatedItems, successfulItems);
          if (this.mainProduct === parentAtClick && successfulItems.has(parentAtClick)) {
            this.onIncludeParentChange(false);
          } else if (selectionsChanged) {
            this.updateOrderConfiguredPrices();
          }
          this.addToOrderComponent?.resetAddToOrderState();
          if (productAddedCount > 0) {
            this.messageService.trigger('orderUpdated');
          }
        }),
      )
      .subscribe({
        next: ({ result: val, sourceItem }) => {
          successfulItems.add(sourceItem);
          if (val?.idArray) {
            orderLinesToRefresh++;
            this.ooeSessionService
              .fetchUpdatedOrderLine({
                id: val.idArray,
                orderNumber: this.openOrder.orderNumber,
              })
              .pipe(takeUntil(this.componentDestroyed$))
              .subscribe((val2) => {
                productAddedCountFinal++;
                if (val2) {
                  refreshUserState();
                }
              });
          }
          productAddedCount++;
          if (selectedItemsCountAtClick > 1) {
            this.toastr.success('Item ' + productAddedCount + '/' + selectedItemsCountAtClick + ' added', null, {
              timeOut: productAddedCount < selectedItemsCountAtClick ? 1000 : 3000,
            });
          } else {
            this.toastr.success('Item added');
          }
        },
        error: (error: unknown) => {
          this.toastr.error(typeof error === 'string' && error ? error : 'Unable to add item to order. Please try again.');
        },
      });
  }

  private uncheckSuccessfulOrderItems(items: IProductOrderItem[], successfulItems: Set<IProductOrderItem>, nested = false): boolean {
    let changed = false;
    for (const item of items) {
      changed = this.uncheckSuccessfulOrderItems(item.associatedItems || [], successfulItems, true) || changed;
      const checkboxDisabled = this.isEAIRules
        ? (nested || item.companySKU !== 'ADDFIT') && (item.isMandatory || item.isConflicting)
        : !nested && item.companySKU !== 'ADDFIT' && item.infoMessage === 'Total of Bundle Items Paint';
      const hasPendingChildren = (item.associatedItems || []).some((child) => this.hasPendingOrderItem(child, successfulItems));
      if (item.isSelected && successfulItems.has(item) && !checkboxDisabled && !hasPendingChildren) {
        item.isSelected = false;
        changed = true;
      }
    }
    return changed;
  }

  private hasPendingOrderItem(item: IProductOrderItem, successfulItems: Set<IProductOrderItem>): boolean {
    if (!this.includeParent && item.cedCategory === AppConsts.SUPPLEMENTARY_CHARGE_GROUP_NAME) {
      return false;
    }
    const isSeparateOrderItem = item.associatedType !== 'Paint' && (item.associatedType !== 'Fit' || item.companySKU === 'ADDFIT');
    return (
      (item.isSelected && isSeparateOrderItem && (!this.isEAIRules || !item.isMandatory) && !successfulItems.has(item)) ||
      (item.associatedItems || []).some((child) => this.hasPendingOrderItem(child, successfulItems))
    );
  }

  public recievechangeEAIRules(isEAIRules: boolean): void {
    this.isEAIRules = isEAIRules;
  }

  public onIncludeParentChange(includeParent: boolean): void {
    this.includeParent = includeParent;
    if (!includeParent) {
      this.uncheckSupplementaryCharges(this.associatedItems);
      this.mainBundleSupplementryGroupSelected = false;
      this.combinedFitSupplementryGroupSelected = false;
      this.combinedPaintSupplementryGroupSelected = false;
    }
    this.updateOrderConfiguredPrices();
  }

  private uncheckSupplementaryCharges(items: IProductOrderItem[], inSupplementaryGroup = false): void {
    for (const item of items) {
      const isSupplementaryGroup = inSupplementaryGroup || item.cedCategory === AppConsts.SUPPLEMENTARY_CHARGE_GROUP_NAME;
      if (isSupplementaryGroup) {
        item.isSelected = false;
      }
      this.uncheckSupplementaryCharges(item.associatedItems || [], isSupplementaryGroup);
    }
  }

  public onAddToOrderInProgress(): void {
    this.dialogService.alert('Adding items to order, please wait until all items have been added.', 'Add To Order In Progress', 'OK');
  }

  public updateOrderItem(item: IProductOrderItem): void {
    if (item?.infoMessage === 'IGNORETOTAL') {
      return;
    }
    if (item?.infoMessage === 'Total of Bundle Items Paint' || item?.infoMessage === 'Total of Bundle Items Fit') {
      this.mainBundleSupplementryGroupSelected = !this.mainBundleSupplementryGroupSelected;
    } else if (
      item?.associatedType == 'Paint' &&
      item?.associatedItems?.length == 0 &&
      item?.infoMessage !== 'Total of Bundle Items Paint' &&
      item?.addtionalProductData?.bundleComponentPaintCodes.length >= 1
    ) {
      this.combinedPaintSupplementryGroupSelected = !this.combinedPaintSupplementryGroupSelected;
    } else if (
      item?.associatedType == 'Fit' &&
      item?.associatedItems?.length == 0 &&
      item?.infoMessage !== 'Total of Bundle Items Fit' &&
      item?.companySKU !== 'ADDFIT' &&
      item?.addtionalProductData?.bundleCombinedFitCodeAndPrice?.length >= 1
    ) {
      this.combinedFitSupplementryGroupSelected = !this.combinedFitSupplementryGroupSelected;
    }

    if (!this.isEAIRules) {
      this.mainBundleSupplementryGroupSelected = false;
      this.combinedFitSupplementryGroupSelected = false;
      this.combinedPaintSupplementryGroupSelected = false;
    }

    this.updateOrderConfiguredPrices();
  }

  private getProductDetail(): void {
    this.isProductLoadingSubject.next(true);
    this.productNotFound = false;
    this.productQuery.mode = DetailLevel.Full;
    this.productQuery.brand = AppConsts.brand;
    this.productQuery.priceList = this.ooeSessionService.priceLists;
    this.productQuery.showUniversalProducts = !!this.selectedVehicleId;
    this.productQuery.vehicleId = this.useVehicleInFilter ? this.selectedVehicleId : null;
    this.epcApiService
      .getProductDetail(this.productQuery)
      .pipe(
        takeUntil(this.componentDestroyed$),
        finalize(() => {
          this.isProductLoadingSubject.next(false);
          window.scroll(0, 0);
        }),
      )
      .subscribe((result) => {
        if (result?.productInfo) {
          this.productOutput = this.transformProductData(result);

          this.buildSRPUrlForBreadcrumb(this.productOutput.productInfo.cedCategoryId, this.productOutput.productInfo.companySKU);

          this.buildTechSpecAttributes(this.productOutput);
          this.buildMainProduct();
          this.buildAssociatedItems();
          this.buildProductImages();
          this.buildPriceAndStock();

          this.isFitted =
            this.productOutput.productInfo.universal || this.productOutput.applications.some((app) => app.paRtsVehicleID == this.selectedVehicleId);

          this.hasAssociatedFittmentWarning = this.productOutput.applications?.length > 0;
          this.hasAssociatedItemWarning =
            this.productOutput.associatedItems?.filter(
              (item) => item.isMandatory && (!this.useVehicleInFilter || (this.useVehicleInFilter && this.selectedVehicleId && item.isFitted)),
            )?.length > 0;
        } else {
          this.productNotFound = true;
        }
      });
  }

  private transformProductData(result: GetProductDetails): GetProductDetailOutput {
    const productOutput = new GetProductDetailOutput({
      productInfo: result.productInfo,
      addFitDescription: result.addFitDescription,
      applications: result.applications,
      attributes: result.attributes,
      images: result.images,
      found: result.found,
      fromProductPage: result.fromProductPage,
      fitDescription: result.fitDescription,
      fittingInstructions: result.fittingInstructions,
      associatedItems: result.associatedItems?.map((item) => {
        const bundleAssociatedItems = item.bundleComponents.map((bundleItem) => {
          return {
            ...bundleItem,
            associatedType: 'Mandatory Bundle',
            isMandatory: true,
          } as AssociatedItem;
        });

        if (item.fitableYN == 'Y') {
          item.associatedItems.push({
            companySKU: item.fitProductCode,
            quantity: 1,
            associatedType: 'Fit',
            unitPrice: item.fitUnitPriceIncTax,
          } as AssociatedItem);
        }

        if (item.paintableYN == 'Y') {
          item.associatedItems.push({
            companySKU: item.paintProductCode,
            quantity: 1,
            associatedType: 'Paint',
          } as AssociatedItem);
        }

        /* sub associatedItems */
        item.associatedItems.forEach((subItem) => {
          if (subItem.fitableYN == 'Y') {
            subItem.associatedItems.push({
              companySKU: subItem.fitProductCode,
              quantity: 1,
              associatedType: 'Fit',
              unitPrice: subItem.fitUnitPriceIncTax || subItem['fitUnitPrice'],
            } as AssociatedItem);
          }
          if (subItem.paintableYN == 'Y') {
            subItem.associatedItems.push({
              companySKU: subItem.paintProductCode,
              quantity: 1,
              associatedType: 'Paint',
            } as AssociatedItem);
          }
        });

        item.associatedItems = item.associatedItems.concat(bundleAssociatedItems);
        return new ProductAssociatedItem(item as any);
      }),
    });
    return productOutput;
  }

  private buildSRPUrlForBreadcrumb(categoryId, companySKU): void {
    this.messageService.trigger('productUpdated', {
      categoryId,
      companySKU,
    });
  }

  private buildPriceAndStock(): void {
  this.getPriceAndStock(this.mainProduct, this.associatedItems)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(() => {
        this.getAllItemsPriceAndStocks();
      });
  }

  private buildProductImages(): void {
    if (this.productOutput.images.length == 0) {
      var defaultImage = new ProductRichContentDto();

      defaultImage.init({
        type: 1,
        fileName: '',
        contentUrl: '',
        contentUrlThumb: '',
        contentDescription: '',
      });

      this.productOutput.images.push(defaultImage);
    }
  }

  private buildTechSpecAttributes(result: GetProductDetailOutput): void {
    if (result.attributes && result.productInfo) {
      this.productInfoAttribute = result.attributes.filter((item) => item.attrGroup === 0 || item.attrGroup === 1);
      const productDimension: ProductAttributeDto[] = [];
      if (result.productInfo.weight) {
        productDimension.push(
          new ProductAttributeDto({
            attrGroup: 0,
            attribute: 'Net Weight(Kg)',
            value: result.productInfo.weight,
            sortNumber: 0,
            filterable: false,
          }),
        );
      }
      if (result.productInfo.width) {
        productDimension.push(
          new ProductAttributeDto({
            attrGroup: 0,
            attribute: 'Width(cm)',
            value: result.productInfo.width,
            sortNumber: 0,
            filterable: false,
          }),
        );
      }
      if (result.productInfo.depth) {
        productDimension.push(
          new ProductAttributeDto({
            attrGroup: 0,
            attribute: 'Height(cm)',
            value: result.productInfo.depth,
            sortNumber: 0,
            filterable: false,
          }),
        );
      }
      if (result.productInfo.length) {
        productDimension.push(
          new ProductAttributeDto({
            attrGroup: 0,
            attribute: 'Length(cm)',
            value: result.productInfo.length,
            sortNumber: 0,
            filterable: false,
          }),
        );
      }
      if (result.productInfo.barCode) {
        productDimension.push(
          new ProductAttributeDto({
            attrGroup: 0,
            attribute: 'Bar Code',
            value: result.productInfo.barCode,
            sortNumber: 0,
            filterable: false,
          }),
        );
      }
      this.productInfoAttribute = [...productDimension, ...this.productInfoAttribute];
      this.productFitmentInfoAttribute = result.attributes.filter((item) => item.attrGroup === 2);
    }
  }

  private buildMainProduct(): void {
    this.mainProduct = this.createOrderItem(this.productOutput.productInfo);
    this.mainProduct.quantity = 1;
  }

  private buildAssociatedItems(): void {
    let items: IProductOrderItem[] = [];
    let combinedPaintCode = [];
    let combinedFitCodeAndPrice = [];
    this.isParentUnitFitCharge = false;
    //loop through this.productOutput.associatedItems and check if any associated type of Fit or Paint
    this.productOutput.associatedItems.forEach((item) => {
      if (item.associatedType === 'Mandatory Bundle') {
        item.associatedItems.forEach((subItem) => {
          if (subItem.associatedType === 'Fit') {
            this.isParentUnitFitCharge = true;
          }
        });
      }
    });
    this.productOutput.associatedItems.forEach((item) => {
      if (item.associatedType == 'Fit' && item.associatedItems?.length == 0) {
        combinedFitCodeAndPrice.push({
          companySKU: item.companySKU,
          isParentBundle: this.productOutput?.productInfo?.isBundle,
          fitUnitPrice: Number(
            item.fitUnitPriceExTax || !this.isParentUnitFitCharge || this.productOutput?.productInfo?.isBundle ? item.unitPrice : 0,
          ),
        });
      }
      if (
        item.associatedItems.some((t) => t.associatedType == 'Fit') &&
        item?.associatedType !== 'Optional' &&
        item?.associatedType !== 'Supplementary Product' &&
        item?.associatedType !== 'Supplementary'
      ) {
        item.associatedItems.forEach((subItem) => {
          if (subItem.associatedType == 'Fit') {
            combinedFitCodeAndPrice.push({ companySKU: subItem.companySKU, fitUnitPrice: Number(subItem.unitPrice) });
          }
        });
      }
      if (item.associatedType == 'Paint' && item.associatedItems?.length == 0) {
        combinedPaintCode.push(item.companySKU);
      }
      if (
        item.associatedItems.some((t) => t.associatedType == 'Paint') &&
        item?.associatedType !== 'Optional' &&
        item?.associatedType !== 'Supplementary Product' &&
        item?.associatedType !== 'Supplementary'
      ) {
        item.associatedItems.forEach((subItem) => {
          if (subItem.associatedType == 'Paint') {
            combinedPaintCode.push(subItem.companySKU);
          }
        });
      }
    });

    this.productOutput.associatedItems.forEach((item) => {
      let orderItem = this.buildAssociateItem(item);

      // Handle Paint (Color Code) items
      if (item.standardDescription == '1871') {
        orderItem.associatedType = item.companySKU.startsWith('CC') ? 'Paint' : 'SupplementaryCharge';
        orderItem.addtionalProductData.supplementGroupItemName = 'PAINTED';
        //orderItem.quantity = 1;
        orderItem.quantity = orderItem?.originalQuantity || 1;
        orderItem.cedCategory = AppConsts.SUPPLEMENTARY_CHARGE_GROUP_NAME;
      }

      // if the item is FIT, add the price as calculated from API
      if ((item.associatedType == 'Fit' && item.associatedItems?.length == 0) || item.associatedItems.some((t) => t.associatedType == 'Fit')) {
        orderItem.uom = 'Each';
        orderItem.addtionalProductData.supplementGroupItemName = 'FITTED';
        items.push({
          ...orderItem,
          addtionalProductData: {
            ...orderItem.addtionalProductData,
            bundleCombinedFitCodeAndPrice: combinedFitCodeAndPrice,
          },
        });
      } else if (item.associatedType == 'Fit') {
        orderItem.uom = 'Each';
        orderItem.addtionalProductData.supplementGroupItemName = 'FITTED';
      } else if (
        (item.associatedType == 'Paint' && item.associatedItems?.length == 0) ||
        (item.associatedItems.some((t) => t.associatedType == 'Paint') && !this.productOutput.productInfo.isBundle)
      ) {
        // if the item is Paint and there are other Paint items, then add to combinedPaintCode

        //orderItem.quantity = 1;
        orderItem.quantity = orderItem?.originalQuantity || 1;

        orderItem.addtionalProductData.supplementGroupItemName = 'PAINTED';
        items.push({
          ...orderItem,
          addtionalProductData: {
            ...orderItem.addtionalProductData,
            bundleComponentPaintCodes: combinedPaintCode,
          },
        });
      } else if (item.associatedType == 'Paint') {
        // orderItem.quantity = 1;
        orderItem.quantity = orderItem?.originalQuantity || 1;
        orderItem.addtionalProductData.supplementGroupItemName = 'PAINTED';
        items.push(orderItem);
      } else {
        items.push(orderItem);
      }
    });
    /* Additional Fit if associatedItems have no Fit*/
    if (this.productOutput.productInfo.fitableYN == 'Y') {
      items.push({
        productNumber: this.productOutput.productInfo.companySKU,
        cedCategory: AppConsts.SUPPLEMENTARY_CHARGE_GROUP_NAME,
        brandId: this.mainProduct.brandId,
        companySKU: 'ADDFIT',
        associatedType: 'Fit',
        quantity: 1,
        addtionalProductData: {
          companyProductTitle: 'Additional Fit',
          supplementGroupItemName: 'Charges in addition to standard product fitment',
        },
        prices: [],
        associatedItems: [],
      } as IProductOrderItem);
    }

    //if the parent product has any mandatory associated items or
    //  bundle component items that have a paint charge then the line in the
    // SUPPLEMENTARY CHARGE section should just read PAINT CHARGE
    // and it should be the sum of the parent product's paint charge plus and mandatory item's / bundle component's paint charge

    if (this.productOutput.productInfo.isBundle || this.productOutput.productInfo.isKit) {
      let bundleMembersThatHasFittingTime = items.filter((t) => t.associatedType == 'Mandatory Bundle' && t.fitableYN == 'Y');
      let bundleMembersThatHasPaintOption = items.filter((t) => t.associatedType == 'Mandatory Bundle' && t.paintableYN == 'Y');

      if (this.productOutput.productInfo.fitableYN != 'Y' && bundleMembersThatHasFittingTime.length) {
        // check if bundle component has fitting time values -> add a fitting line to the main bundle supplementary charge
        let fitProdCode = bundleMembersThatHasFittingTime[0].fitProductCode;
        let fitUnitPriceExTax = sumBy(
          bundleMembersThatHasFittingTime,
          (item) =>
            item.quantity *
            Number(item.addtionalProductData.fitBundleUnitPriceExTax ? item.addtionalProductData.fitBundleUnitPriceExTax : item.fitUnitPriceExTax),
        );
        let fitUnitPriceIncTax = sumBy(
          bundleMembersThatHasFittingTime,
          (item) =>
            item.quantity *
            Number(item.addtionalProductData.fitBundleUnitPriceIncTax ? item.addtionalProductData.fitBundleUnitPriceIncTax : item.fitUnitPriceIncTax),
        );

        items.push({
          productNumber: fitProdCode,
          companySKU: fitProdCode,
          cedCategory: AppConsts.SUPPLEMENTARY_CHARGE_GROUP_NAME,
          brandId: this.mainProduct.brandId,
          associatedType: 'Fit',
          quantity: 1,
          addtionalProductData: {
            companyProductTitle: 'Fit',
            supplementGroupItemName: 'FITTED',
            isBundleMetaInfo: true,
            bundleComponentFitExTax: fitUnitPriceExTax,
            bundleComponentFitIncTax: fitUnitPriceIncTax,
          },
          prices: [],
          customerUnitPrice: fitUnitPriceExTax,
          customerTaxedUnitPrice: fitUnitPriceIncTax,
          associatedItems: [],
          fitProductCode: fitProdCode,
          fitProductDesc: fitProdCode,
          uom: 'Each',
          fitableYN: 'Y',
          fittedYN: 'N',
        } as IProductOrderItem);
        //AIHD-53891 // logic added (when we are showing charge to fit, We always showing additional fit info)
        items.push({
          productNumber: this.productOutput.productInfo.companySKU,
          cedCategory: AppConsts.SUPPLEMENTARY_CHARGE_GROUP_NAME,
          brandId: this.mainProduct.brandId,
          companySKU: 'ADDFIT',
          associatedType: 'Fit',
          quantity: 1,
          addtionalProductData: {
            companyProductTitle: 'Additional Fit',
            supplementGroupItemName: 'Charges in addition to standard product fitment',
          },
          prices: [],
          associatedItems: [],
        } as IProductOrderItem);
      }

      if (this.productOutput.productInfo.paintableYN != 'Y' && bundleMembersThatHasPaintOption.length) {
        let paintCodes = [];
        bundleMembersThatHasPaintOption.forEach((itm) => {
          if (paintCodes.find((cd) => cd == itm.companySKU) == undefined) {
            paintCodes.push(itm.paintProductCode);
          }
        });

        items.push({
          brandId: this.mainProduct.brandId,
          companySKU: '', // N/A
          paintDesc: '', // N/A
          paintProductCode: '', // N/A because there can be multiple paint codes from multiple bundle items
          associatedType: 'Paint',
          cedCategory: AppConsts.SUPPLEMENTARY_CHARGE_GROUP_NAME,
          originalQuantity: 1,
          quantity: 1,
          associatedItems: [],
          prices: [],
          paintableYN: 'Y',
          paintYN: 'N',
          uom: 'Each',
          addtionalProductData: {
            companyProductTitle: 'Bundle Items Paint',
            supplementGroupItemName: 'PAINTED',
            isBundleMetaInfo: true,
            bundleComponentPaintCodes: paintCodes,
          },
          infoMessage: 'Total of Bundle Items Paint',
        } as IProductOrderItem);
      }
    }

    this.associatedItems = items;
    this.updateOrderConfiguredPrices();
  }

  private buildAssociateItem(item: ProductAssociatedItem): IProductOrderItem {
    let orderItem = this.createOrderItem(item);

    (item.associatedItems || []).forEach((assocItm) => {
      if (assocItm.associatedType == 'Fit') {
        let subOrderItemFitted = this.createOrderItem(assocItm);

        subOrderItemFitted.uom = 'Each';
        subOrderItemFitted.addtionalProductData.supplementGroupItemName = 'FITTED';
        orderItem.associatedItems.push(subOrderItemFitted);
      } else if (assocItm.associatedType == 'Paint') {
        let subOrderItemPaitted = this.createOrderItem(assocItm);

        subOrderItemPaitted.addtionalProductData.supplementGroupItemName = 'PAINTED';

        orderItem.associatedItems.push(subOrderItemPaitted);
      } else {
        orderItem.associatedItems.push(this.buildAssociateItem(assocItm));
      }
    });

    return orderItem;
  }

  private updateOrderConfiguredPrices(): void {
    const mainQuantity = this.mainProduct.quantity || 0;
    this.configuredPrices = [];

    this.mainProduct.prices.forEach((price) => {
      if (!this.includeParent) {
        const addedPrice = this.associatedItems
          .filter((item) => this.isSelectedSeparateOrderItem(item))
          .reduce((total, item) => total + this.getSelectedOrderItemPrice(price.priceScheduleDescription, item), 0);
        this.configuredPrices.push({ totalPrice: addedPrice, defaultPriceTF: price.defaultPriceTF });
        return;
      }
      let addedPrice = 0;
      let addedPriceMandatory = 0;
      let bundlePriceMandatory = 0;
      let bundleBasePriceMandatory = 0;
      let addedExtraFitPriceBundle = 0;

      if (mainQuantity > 0) {
        // First, collect all SKUs that are sub-items of selected bundles to avoid double-counting
        const subItemsInSelectedBundles = new Set<string>();
        this.associatedItems.forEach((item) => {
          if (item.isSelected && item.isBundle && item.associatedItems?.length > 0) {
            item.associatedItems.forEach((subItem) => {
              if (subItem.companySKU) {
                subItemsInSelectedBundles.add(subItem.companySKU);
              }
            });
          }
        });

        this.associatedItems.forEach((item) => {
          // Handle non-mandatory associated items

          if (item.quantity && item.isSelected && !item.isMandatory && item.prices?.length && !this.mainBundleSupplementryGroupSelected) {
            const itemPrice = this.getAssociatedItemPrice(price.priceScheduleDescription, item, item.associatedType === 'Optional');
            addedPrice += itemPrice;
          }
          if (
            item.quantity &&
            item.isSelected &&
            this.mainProduct.isBundle &&
            !this.hasParentBundleFitCharge &&
            item?.companySKU === 'FIT' &&
            item?.cedCategory === 'SUPPLEMENTARY CHARGE' &&
            item?.associatedType === 'Fit' &&
            this.isEAIRules &&
            item?.associatedItems?.length == 0 &&
            item?.infoMessage !== 'Total of Bundle Items Fit' &&
            (item?.addtionalProductData?.bundleCombinedFitCodeAndPrice?.length > 1 || item.addtionalProductData?.isBundleMetaInfo)
          ) {
            addedExtraFitPriceBundle = this.getAssociatedItemPrice(price.priceScheduleDescription, item);
          }

          // Handle mandatory associated items
          if (item.isMandatory && item.prices?.length) {
            // Check if this item is already included in a selected bundle
            const isInSelectedBundle = subItemsInSelectedBundles.has(item.companySKU);

            const basePrice = this.getAssociatedItemPrice(price.priceScheduleDescription, item, item.associatedType === 'Optional');

            if (item.isSelected && !isInSelectedBundle) {
              const isMandatoryType =
                (!this.mainProduct?.isBundle && !this.mainBundleSupplementryGroupSelected && item.associatedType === 'Mandatory') ||
                item.associatedType === 'Fit' ||
                item.associatedType === 'Paint' ||
                item.associatedType === 'SupplementaryCharge';

              if (isMandatoryType) {
                addedPriceMandatory += basePrice;
              } else if (
                !this.mainProduct?.isBundle &&
                !this.mainBundleSupplementryGroupSelected &&
                !this.isEAIRules &&
                item.associatedType === 'Mandatory Bundle' &&
                this.isSubItemSelected
              ) {
                const basePriceItem =
                  item.associatedType === 'Mandatory Bundle'
                    ? item.prices[0]
                    : item.prices.find((t) => t.priceScheduleDescription == price?.priceScheduleDescription);
                addedPriceMandatory += basePrice - (item?.quantity * basePriceItem?.taxedUnitPrice || 0);
                this.isSubItemSelected = false;
              } else if (this.mainProduct?.isBundle && item.associatedType === 'Mandatory Bundle' && this.mainBundleSupplementryGroupSelected) {
                bundlePriceMandatory += basePrice;
              } else if (this.mainProduct?.isBundle && (item.associatedType === 'Mandatory Bundle' || item.associatedType === 'Mandatory')) {
                // When isBundle and isEAIRules are true, add Mandatory Bundle item prices to bundleBasePriceMandatory
                bundleBasePriceMandatory += basePrice;
              }
            }
          }
        });
      }

      if (!this.mainProduct?.isBundle || !this.mainBundleSupplementryGroupSelected) {
        const mainProductPrice = this.mainProduct?.isBundle ? 0 : mainQuantity * price.taxedUnitPrice;

        this.configuredPrices.push({
          totalPrice: mainProductPrice + addedPrice + addedPriceMandatory + bundleBasePriceMandatory - addedExtraFitPriceBundle,
          defaultPriceTF: price?.defaultPriceTF,
        });
      } else {
        this.configuredPrices.push({
          totalPrice: bundlePriceMandatory + addedPrice,
          defaultPriceTF: price?.defaultPriceTF,
        });
      }
    });
    if (!this.mainProduct?.isBundle) {
      this.configuredPrices = (this.configuredPrices || []).filter((t) => t?.defaultPriceTF === true);
    }
    this.currencyCode = this.mainProduct.prices?.length ? this.mainProduct.prices[0].currency : 'AUD';
  }
  


  
  private getSelectedOrderItemPrice(priceScheduleDescription: string, item: IProductOrderItem): number {
    if (!this.isEAIRules && (item.isBundle || item.isKit)) {
      return item.associatedItems
        .filter((child) => this.isSelectedSeparateOrderItem(child))
        .reduce((total, child) => total + this.getSelectedOrderItemPrice(priceScheduleDescription, child), 0);
    }
    return this.getAssociatedItemPrice(priceScheduleDescription, item);
  }

  private getAssociatedItemPrice(
    priceScheduleDescription: string,
    item: IProductOrderItem,
    parentAssociatedTypeOptional = false,
    subitem = false,
  ): number {
    if (!this.includeParent && item.cedCategory === AppConsts.SUPPLEMENTARY_CHARGE_GROUP_NAME) {
      return 0;
    }
    let parentAssociatedTypeOptionalValue = parentAssociatedTypeOptional;

    let addedPrice = 0;
    let basePriceItem =
      item.associatedType == 'Fit' ? item.prices[0] : item.prices.find((t) => t.priceScheduleDescription == priceScheduleDescription);

    if (basePriceItem) {
      let basePrice = basePriceItem.taxedUnitPrice;

      item.associatedItems.forEach((subItem) => {
        if (this.hasParentBundleFitCharge && item.associatedType === 'Mandatory Bundle' && subItem.associatedType === 'Fit') {
          return;
        }
        if (subItem.isSelected && subItem.prices?.length && subItem.quantity) {
          const subItemPrice = this.getAssociatedItemPrice(priceScheduleDescription, subItem);
          basePrice += subItemPrice;
          this.isSubItemSelected = true;
        }
      });

      addedPrice = item.quantity * basePrice;
    }

    return addedPrice;
  }

  private get hasParentBundleFitCharge(): boolean {
    return this.includeParent && this.isEAIRules && this.mainProduct.isBundle &&
      Number(this.mainProduct.fitUnitPriceIncTax) > 0;
  }

  private createOrderSilent(quantity: number) {
    this.ooeAPIServiceProxy
      .createOrderSilent()
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe((result) => {
        if (!result || result?.ErrorFlag == '1') {
          this.toastr.error(result.ErrorMessage);
          return;
        }

        this.toastr.success('Order Created');
        // added for PBI-4350 request
        this.openOrder.orderNumber = result.OrderNumber;
        this.addItemToOrder(quantity, true);
        // Removed for PBI-4350 request
        // this.ooeSessionService
        //   .fetchUserState()
        //   .pipe(takeUntil(this.componentDestroyed$))
        //   .subscribe(({ OpenOrder }) => {
        //     this.openOrder = OpenOrder;
        //     this.addItemToOrder(quantity, true);
        //     return;
        //   });
      });
  }

  private getNewItem(
    results: AddItemToOrderInputDto[],
    validatedItem: IProductOrderItem,
    associatedItems: IProductOrderItem[],
    sourceItems: IProductOrderItem[],
    parentQuantity?: number,
  ) {
    if (!this.includeParent && validatedItem.cedCategory === AppConsts.SUPPLEMENTARY_CHARGE_GROUP_NAME) {
      return;
    }
    if (!this.includeParent && validatedItem === this.mainProduct) {
      associatedItems.filter((item) => this.isSelectedSeparateOrderItem(item)).forEach((item) => {
        this.getNewItem(results, item, item.associatedItems, sourceItems);
      });
      return;
    }
    const unitPriceExTax = validatedItem.customerUnitPrice;
    const unitPriceIncTax = validatedItem.customerTaxedUnitPrice;
    let quantity = validatedItem.quantity ? validatedItem.quantity : 0;

    if (
      validatedItem.associatedType == 'Mandatory Bundle' ||
      (validatedItem.associatedType == 'Fit' && validatedItem.companySKU != 'ADDFIT') ||
      validatedItem.associatedType == 'Paint' ||
      validatedItem.associatedType == 'Mandatory'
    ) {
      quantity *= parentQuantity ? parentQuantity : 1;
    }

    // if validated item is bundle but Enforce Association rule checkbox is not ticked, only add selected bundle items
    // else add only the bundle itemNumber ifself, the api will automatically add bundle items.
    if ((validatedItem.isKit || validatedItem.isBundle) && !this.isEAIRules) {
      associatedItems
        .filter((x) => x.isSelected)
        .map((item) => {
          this.getNewItem(results, item, item.associatedItems, sourceItems, quantity);
        });
    } else {
      if (quantity > 0) {
        let newItem = new AddItemToOrderInputDto({
          brand: AppConsts.brand,
          orderNumber: this.openOrder.orderNumber,
          parentItemCode: validatedItem.companySKU,
          parentItemDesc: validatedItem.addtionalProductData.companyProductTitle,
          parentItemQty: quantity.toString(),
          parentItemUOM: validatedItem.uom,
          paintableYN: validatedItem.addtionalProductData.paintableYN,
          paintYN: 'N',
          fitableYN: validatedItem.addtionalProductData.fitableYN,
          fittedYN: 'N',
          unitPriceExTax: unitPriceExTax,
          unitPriceIncTax: unitPriceIncTax,
          extPriceExTax: Number(Number(unitPriceExTax) * quantity).toFixed(2),
          extPriceIncTax: Number(Number(unitPriceIncTax) * quantity).toFixed(2),
          partsVehicleID: this.openOrder.partsVehicleID,
          fitProductCode: validatedItem.fitProductCode,
          fitProductDesc: validatedItem.fitProductCode,
          fitUnitPriceExTax: validatedItem.fitUnitPriceExTax,
          fitUnitPriceIncTax: validatedItem.fitUnitPriceIncTax,
          paintDesc: validatedItem.paintDesc,
          paintProductCode: validatedItem.paintProductCode,
          parentLineNumber: 0,
          productNumber: validatedItem.productNumber,
          quantity: validatedItem.quantity,
          nonStockLineYN: '',
          overridePriceAllowedYN: '',
          assocItems: [],
        });

        if (associatedItems.some((t) =>
          t.associatedType == 'Fit' && t.isSelected && t.companySKU != 'ADDFIT' &&
          (this.includeParent || t.cedCategory !== AppConsts.SUPPLEMENTARY_CHARGE_GROUP_NAME)
        )) {
          newItem.fittedYN = 'Y';
        }

        if (associatedItems.some((t) =>
          t.associatedType == 'Paint' && t.isSelected &&
          (this.includeParent || t.cedCategory !== AppConsts.SUPPLEMENTARY_CHARGE_GROUP_NAME)
        )) {
          newItem.paintYN = 'Y';
        }

        results.push(newItem);
        sourceItems.push(validatedItem);

        if (!this.isEAIRules) {
          // if EAI rule is not enforced, add selected associated items as new separated line
          associatedItems.forEach((x) => {
            if (x.isSelected && x.associatedType != 'Paint' && (x.associatedType != 'Fit' || x.companySKU == 'ADDFIT')) {
              this.getNewItem(results, x, x.associatedItems, sourceItems, quantity);
            }
          });
        } else {
          // if EAI rule is enforced,
          // do nothing to mandatory associated items (because it will automatically added by api),
          // only collect selected optional ones to new lines
          associatedItems.forEach((x) => {
            if (x.isSelected && !x.isMandatory && x.associatedType != 'Paint' && (x.associatedType != 'Fit' || x.companySKU == 'ADDFIT')) {
              this.getNewItem(results, x, x.associatedItems, sourceItems, quantity);
            }
          });
        }
      } else {
        // handle the case main product quantity = 0 but customer select some associated items to build.
        // if EAIR is ticked, DONOT add mandatory associated item (which have selection checkboxes disabled)
        associatedItems.forEach((x) => {
          if (
            x.isSelected &&
            x.associatedType != 'Fit' &&
            x.associatedType != 'Paint' &&
            (!this.isEAIRules || (this.isEAIRules && x.associatedType != 'Mandatory'))
          ) {
            this.getNewItem(results, x, x.associatedItems, sourceItems, quantity);
          }
        });
      }
    }
  }

  private isSelectedSeparateOrderItem(item: IProductOrderItem): boolean {
    return item.isSelected &&
      item.cedCategory !== AppConsts.SUPPLEMENTARY_CHARGE_GROUP_NAME &&
      (!this.isEAIRules || !item.isMandatory) &&
      item.associatedType !== 'Paint' &&
      (item.associatedType !== 'Fit' || item.companySKU === 'ADDFIT');
  }

  private createOrderItem(item: any): IProductOrderItem {
    return {
      productNumber: item.productNumber,
      attributes: item.attributes,
      cedCategoryId: item.cedCategoryId,
      cedCategory: item.cedCategory,
      brandId: item.brandId,
      brandName: item.brandName,
      subBrand: item.subBrand,
      companySKU: item.companySKU || item.productNumber,
      isMandatory: item.isMandatory,
      associatedType: item.associatedType,
      isSelected: item.isSelected || item.isMandatory,
      originalQuantity: item.quantity,
      quantity: item.quantity,
      associatedItems: [],
      stocks: null,
      prices: [],
      fitProductCode: item.fitProductCode,
      fitProductDesc: item.fitProductDesc,
      fitUnitPriceExTax: item.fitUnitPriceExTax,
      fitUnitPriceIncTax: item.fitUnitPriceIncTax || item.fitUnitPrice || 0,
      paintDesc: item.paintDesc,
      paintProductCode: item.paintProductCode,
      customerCurrency: '',
      customerUnitPrice: '',
      customerTaxedUnitPrice: '',
      paintableYN: item.paintableYN,
      paintYN: 'N',
      fitableYN: item.fitableYN,
      fittedYN: 'N',
      numberOfComponentsPerProduct: item.uom,
      uom: item.uom,
      addtionalProductData: item,
      infoMessage: item.associatedType == 'Mandatory Bundle' ? 'Mandatory Bundle Item' : item.associatedType + ' Associated Item',
      isConflicting: false,
      conflictingWith: '',
      isBundle: item.isBundle,
      isKit: item.isKit,
      productType: item.productType,
      defaultPriceTF: item?.defaultPriceTF,
    };
  }

  private getPrices(itemCode: string): FetchItemPriceGroupItemPriceObject[] {
    const priceAndStockItem = this.priceAndStockItems?.find((item) => item.itemCode === itemCode);

    if (priceAndStockItem) {
      const prices = (priceAndStockItem.priceList || []).map((priceItem) => {
        return new FetchItemPriceGroupItemPriceObject({
          priceSchedule: priceItem.priceScheduleCode,
          priceScheduleDescription: priceItem.priceScheduleDescription,
          currency: priceItem.currency,
          unitPrice: Number(priceItem.exTaxUnitPrice),
          taxedUnitPrice: Number(priceItem.taxedUnitPrice),
          taxedYN: priceItem.taxedYN,
          quantity: Number(priceItem.quantity),
          priceLabel: priceItem.priceScheduleDescription,
          defaultPriceTF: priceItem?.defaultPriceTF,
        });
      });

      return prices;
    }

    return [];
  }

  private getStock(itemCode: string): ItemAvaibility {
    const priceAndStockItem = this.priceAndStockItems?.find((item) => item.itemCode === itemCode);

    /* TODO: Check with Beau about availabilityMode, qtyUncommitted and lowMediumHighValue */
    if (priceAndStockItem) {
      return {
        availabilityMode: '1',
        SearchResults: (priceAndStockItem.stock || []).map((item) => {
          return {
            branchCode: item.branchCode,
            branchName: item.branchName,
            qtyAvailable: item.qtyAvailable,
            qtyUncommitted: null,
            lowMediumHighValue: null,
          };
        }),
      } as ItemAvaibility;
    }
    return {
      availabilityMode: '1',
      SearchResults: [],
    } as ItemAvaibility;
  }

  private getAllItemsPriceAndStocks(): void {
    /* init main product prices */
    this.mainProduct.prices = this.getPrices(this.mainProduct.companySKU);
    this.mainProduct.stocks = this.getStock(this.mainProduct.companySKU);
    // this.updateOrderConfiguredPrices();

    /* init associatedItems prices */
    const associatedItems: IProductOrderItem[] = [];
    this.associatedItems.forEach((item) => {
      this.traverse(this.mainProduct, item, associatedItems);
    });

    associatedItems.forEach((item) => {
      item.prices = this.getPrices(item.companySKU);
      item.stocks = this.getStock(item.companySKU);
    });
    this.updateOrderConfiguredPrices();
  }

  /* this function to generate list of items that need to get prices */
  private traverse(parentNode: IProductOrderItem, node: IProductOrderItem, allItems: IProductOrderItem[] = []): void {
    /* Fit get the prices from parent */
    if (node.associatedType == 'Fit' && node.companySKU === 'FIT') {
      node.customerCurrency = this.currencyCode;

      if (!node.customerUnitPrice) {
        node.customerUnitPrice = parentNode.fitUnitPriceExTax;
      }

      if (!node.customerTaxedUnitPrice) {
        node.customerTaxedUnitPrice = parentNode.fitUnitPriceIncTax || parentNode['fitUnitPrice'] || 0;
      }

      node.prices = [
        new FetchItemPriceGroupItemPriceObject({
          priceSchedule: null,
          priceScheduleDescription: 'My Price',
          currency: this.currencyCode,
          unitPrice: Number(node.customerUnitPrice),
          taxedUnitPrice: Number(node.customerTaxedUnitPrice),
          taxedYN: 'N',
          quantity: 1,
          priceLabel: 'My Price',
          defaultPriceTF: node?.defaultPriceTF,
        }),
      ];
      node.stocks = this.getStock(node.companySKU);
    } else {
      allItems.push(node);
    }

    node.associatedItems?.forEach((childNode) => {
      this.traverse(node, childNode, allItems);
    });
  }

  private refreshPricesWithPostCode() {
    if (this.mainProduct) {
      this.buildPriceAndStock();
    }
  }

  private getPriceAndStock(
    mainProduct: IProductOrderItem,
    associatedItems: IProductOrderItem[],
  ): Observable<{
    items: PriceAndStock[];
  }> {
    const input: GetPriceAndStockInput = { itemCodes: [] };
    input.itemCodes.push({
      itemCode: mainProduct.companySKU,
      quantity: mainProduct.quantity,
    });

    this.getAllAssociatedItems(associatedItems).forEach((item) => {
      input.itemCodes.push({
        itemCode: item.companySKU,
        quantity: item.quantity,
      });
       if(item.associatedType ==='Optional'){
         item.associatedItems?.forEach((subItem)=>{
          if(subItem.associatedType ==="Mandatory"){
            input.itemCodes.push({
             itemCode: subItem.companySKU,
             quantity: subItem.quantity,
           });
          }
         });
        }
    });

    return this.epcApiService.getPriceAndStock(input).pipe(
      map((res) => {
        this.priceAndStockItems = res.items;

        return res;
      }),
    );
  }

  private getAllAssociatedItems(associatedItems: IProductOrderItem[], currentItems: IProductOrderItem[] = [], isBundle = false): IProductOrderItem[] {
    associatedItems.forEach((item) => {
      const existed = currentItems.some((i) => i.companySKU == item.companySKU);

      if (!existed && item.companySKU) {
        if (!isBundle || (isBundle && item.associatedType.includes('CC'))) {
          currentItems.push(item);
        }
      }

      if (item.associatedItems?.length > 0) {
        this.getAllAssociatedItems(item.associatedItems, currentItems, item.isBundle);
      }
    });

    return currentItems;
  }
}
